// extracted by mini-css-extract-plugin
export default {"login":"Login_login__Lwv0l","forms":"Login_forms__ba5lo"};